import {
  FETCH_SERVICE_PRODUCTS,
  FETCH_SERVICE_PRODUCTS_COMPLETED,
  FETCH_SERVICE_PRODUCTS_FAILED,
} from "./actions";

const initialState = {
  list: [],            // [{ id, name, price, pricePerPerson, categoryName, role }, ...]
  loading: false,
  isInitialized: false,
};

const reducers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SERVICE_PRODUCTS:
      return { ...state, loading: true };
    case FETCH_SERVICE_PRODUCTS_COMPLETED:
      return {
        ...state,
        loading: false,
        isInitialized: true,
        list: action.payload?.result || [],
      };
    case FETCH_SERVICE_PRODUCTS_FAILED:
      // On garde la liste précédente si elle existe (cache local)
      return { ...state, loading: false, isInitialized: true };
    default:
      return state;
  }
};

export default reducers;
